import i18next from 'i18next'
import { FormErrors } from 'redux-form'

// types
// eslint-disable-next-line import/no-cycle
import { ILoginForm } from '../../../types/interfaces'

export default (values: ILoginForm) => {
	const errors: FormErrors<ILoginForm> = {}

	if (!values?.username) {
		errors.username = i18next.t('loc:Toto pole je povinné') as string
	}

	if (!values?.password) {
		errors.password = i18next.t('loc:Toto pole je povinné') as string
	}

	return errors
}
